import { FC, JSXElementConstructor, PropsWithChildren, ReactNode } from 'react'

interface ComposeProps {
  components: Array<JSXElementConstructor<PropsWithChildren<unknown>>>
  children: ReactNode
}

export const Compose:FC<ComposeProps> = ({ components = [], children }) => {

  return (
    <>
      {components.reduceRight((acc, Comp) => {
        return <Comp>{acc}</Comp>
      }, children)}
    </>
  )
}